import type {LokalisierungsProvider} from "@k/global/Localizer";
import {LogoUebersichtListe} from "../entwurfSelObListe";
import {LogoPoolController} from "../controllerModules/logoPoolController";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {owayoUtils} from "../owayoUtils";
import {ENTWURF_EVENTNAMES, SELOBEVENTNAMES, SELOBTAB_EVENTNAMES} from "@k/global/GlobalEventnames";
import {Logopool} from "./logopool";
import globalsObject, {trackPageview} from "../globalsObject";
import {HTMLPrinter} from "@k/global/htmlprinter";
import {PopupTools} from "@k/global/popupTools";
import {KIOverlayNavigationButtons} from "../ki_images/KIOverlayNavigationButtons";
import {arrayIndexByKeyValue} from "@k/global/arrayHelper";
import {KIOverlaySelectors, showKI_Image_Overlay} from "../ki_images/KIOverlaySelectors";
import {LogoFromPromptGenerator} from "../ki_images/generateLogoFromPrompt";
import {SelectedFeature} from "@k/js/product";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";
import {StockLogoSearch} from "@k/js/stocklogos/stocklogoSearch";

export type KI_Logo_Preset = {
    ID;
    PresetName;
    PictureTyp;
    PictureStyle;
    Background;
    Keywords;
    filenamePreview;
}

export enum LogoTargetAfterChoosing {
    LIBRARY = "library",
    DRAFT = "draft",
    AI = "aiLogo"
}

export class RahmentabsLogoReiter extends EventListener {
    public static logoTargetAfterChoosing:LogoTargetAfterChoosing = LogoTargetAfterChoosing.DRAFT;
    public static  aiLogoPresets = [] as KI_Logo_Preset[];

    private readonly localizer: LokalisierungsProvider;
    private readonly uebersichtListe :LogoUebersichtListe;
    private readonly logoPool: Logopool;
    private readonly logoPoolController: LogoPoolController;

    private static readonly LOGOPOOL_OVERLAY_SELECTOR  = ".overlay-logo-upload";
    // private static readonly EDIT_OVERLAY_SELECTOR = ".overlay-logo_edit";

    constructor(localizer:LokalisierungsProvider, logoPoolController:LogoPoolController) {
        super();
        this.localizer = localizer;
        this.logoPoolController = logoPoolController;
        this.logoPool = new Logopool(logoPoolController, localizer);
        this.uebersichtListe = new LogoUebersichtListe(".logo-edit");
        this.initEventListeners();
        this.initButtonEventHandlers();
        this.fillUebersichtLogosList();
    }

    private fillUebersichtLogosList = ()=>{


        this.uebersichtListe.fillSlider(owayoUtils.removeClonesFromArray(globalsObject.controller.selObController.getLogoObjects()));
        if (globalsObject.controller.selObController.getLogoObjects().length > 0) {
            $(".logo-btn-heading").addClass(("out"));
        }
        else{
            $(".logo-btn-heading").removeClass(("out"));
        }
    }
    // public openLogoBibliothek() {
    //     $(RahmentabsLogoReiter.LOGOPOOL_OVERLAY_SELECTOR).addClass("active");
    // }
    private initEventListeners() {
        const $this = this;
        this
            .addEventListener(SELOBEVENTNAMES.DELETED, ()=>{
                RahmentabsLogoReiter.hideOverlays();
                this.fillUebersichtLogosList();
            })
            .addEventListener("selobsChangedAfterProductChangeEvent", ()=> $this.fillUebersichtLogosList())
            .addEventListener(SELOBTAB_EVENTNAMES.TABOPENED, (data:{category:string})=>data.category === "logo" ? this.fillUebersichtLogosList() : RahmentabsLogoReiter.hideOverlays())
            .addEventListener(SELOBEVENTNAMES.SELECTION_CLEARED, ()=>RahmentabsLogoReiter.hideOverlays())
            .addEventListener("setButtonVisibilityForFeaturesEvent", (data)=>this.setAILogoVisibility(data))
            // .addEventListener(ENTWURF_EVENTNAMES.LOADEDENTWURF_INITIALIZED, ()=>this.fillUebersichtLogosList())
            .addEventListener("logoObjectsLoaded", ()=>this.fillUebersichtLogosList())
        ;
    }

    public static showLogoEditOverlay() {
        $(".overlay-logo_edit").addClass("active");
        $(".logo-new").removeClass("active");
    }

    public static hideOverlays() {
        $(".overlay-logo_edit, .overlay-logo-upload, .overlay-owayo-logopool, .overlay-owayo-logopool_choice, .overlay-owayo-logopool_searchresults").removeClass("active");
        $(".logo-new").addClass("active");
    }

    private static openLogoLibrary() {
        $(".overlay-owayo-logopool").addClass("active");
        //$([RahmentabsLogoReiter.LOGOPOOL_OVERLAY_SELECTOR, ".overlay-owayo-logopool"].join(",")).addClass("active")
    }

    private static loadAILogoPresets() {
        globalsObject.resourceManager.registerResource({
            resourceName: "loadAILogoPresets.php",
            failHandler: function () {
                globalsObject.errorHandler.handleError("ajaxFail", "loadAILogoPresets.php", "error generating AI logo");
            },
            invalidatedWhen:"getAILogoPresets"
        }).load({
            url: "/konfigurator_php/ki_logos/loadAILogoPresets.php",
            method: "GET",
            dataType: "json"
        });
    }

    private static getAIPresetOverviewEntry(preset:any) {
        const p = HTMLPrinter;

        return p.liWithProps(
            p.cssClass("logo-box"),
            p.dataProp("presetid")(preset.PresetName)
        )(
            p.img(p.cssClass("logo-box-image-owayo"), p.alt(preset.PresetName), p.src("https://static.owayo-cdn.com/"+preset.filenamePreview)),
            p.span(preset.PresetName)
        );
    }

    private fillAILogoPresetSelection(){
        const container = $(".overlay-ki-stilrichtung .logo-pool");
        const presetSelector = <HTMLSelectElement>document.getElementById('ki_style');
        container.empty();
        RahmentabsLogoReiter.aiLogoPresets.forEach( (preset) => {
                presetSelector.options[presetSelector.options.length] = new Option(preset.PresetName, preset.PresetName);
                container.append(RahmentabsLogoReiter.getAIPresetOverviewEntry(preset));
            });

        $(".overlay-ki-stilrichtung .logo-box").off().on("click", function() {
            const presetID = $(this).data("presetid");
            $("#ki_style").val(presetID);
            $(".overlay-ki-prompt").addClass('active');
        });
    }

    private ai_LogosAllowed(features:SelectedFeature[]) {
        return arrayIndexByKeyValue(features, 'featuredObject', 'Bedruckung KI Logo')>-1 &&
        //this.logoPoolController.model.getLand().toUpperCase() ==='DE' &&
        this.logoPoolController.model.getWebsportFuerProduktAuswahlNormalized() ==='productservice'
    }

    private setAILogoVisibility(features){
        let $this = this;
        if (!this.ai_LogosAllowed(features)){
            //$("#logoOwayoAI").addClass("ele-hidden");
            $(".ki-btn-wrapper").addClass("out");
            return;
        }

        if(RahmentabsLogoReiter.aiLogoPresets.length===0){
            globalsObject.resourceManager.executeInvalidation("getAILogoPresets");
            RahmentabsLogoReiter.loadAILogoPresets();
            globalsObject.resourceManager.createTask("loadAILogoPresets")
                .when("loadAILogoPresets.php", "loaded")
                .thenDo(function(resourceData) {
                    RahmentabsLogoReiter.aiLogoPresets = resourceData["loadAILogoPresets.php"].presets;
                    $this.fillAILogoPresetSelection();
                    //$("#logoOwayoAI").removeClass("ele-hidden");
                    $(".ki-btn-wrapper").removeClass("out");
                });
        }
        else {
            //$("#logoOwayoAI").removeClass("ele-hidden");
            $(".ki-btn-wrapper").removeClass("out");
        }
    }

    private initButtonEventHandlers() {
        const $this = this;
        $("#libraryLogo").click(function(){
            if ($this.logoPoolController.model.user.isLoggedIn() === false) {
                EventVerteiler.broadcast("displayNotLoggedInWarningEvent", "warningNotLoggedIn");
            }
            RahmentabsLogoReiter.hideOverlays();
            $(RahmentabsLogoReiter.LOGOPOOL_OVERLAY_SELECTOR).addClass("active");
            trackPageview("konfitrack-logohinzugefuegt.htm");
            globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_ADD_LOGO);
        });

        $(".ki-request-wrapper").on("click", ()=>{
            EventVerteiler.broadcast("displayDialogEvent", {dialog: "ki_weitere_anfargen"});
        })

        $(RahmentabsLogoReiter.LOGOPOOL_OVERLAY_SELECTOR).find(".close").click(()=>$(RahmentabsLogoReiter.LOGOPOOL_OVERLAY_SELECTOR).removeClass("active"));

        $("#logoPoolLogo").on("click", ()=> {
            RahmentabsLogoReiter.logoTargetAfterChoosing = LogoTargetAfterChoosing.DRAFT;
            RahmentabsLogoReiter.hideOverlays();
            RahmentabsLogoReiter.openLogoLibrary();
            StockLogoSearch.showSearchbar();
        })

        $("#logoOwayoAI").on("click", ()=> {
            if ($this.logoPoolController.model.user.isLoggedIn() === false) {
                EventVerteiler.broadcast("displayDialogEvent", {
                    dialog: "warningNotLoggedInFunctionLocked",
                    callbacks: [()=>{},()=>PopupTools.openBenutzerdatenPopupMitVorbelegung(globalsObject.iframeViewController)]
                });
                //EventVerteiler.broadcast("displayNotLoggedInWarningEvent", "warningNotLoggedInFunctionLocked");
            }
            else{
                $(".ki-request-number").html($this.logoPoolController.model.user.getRemainingAILogoCredits().toString());
                showKI_Image_Overlay(KIOverlaySelectors.CHOOSE_STYLE);
                KIOverlayNavigationButtons.init()
            }
        })

        LogoFromPromptGenerator.init($this.logoPoolController);
    }
}
